import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useDispatch, useSelector} from "react-redux";
import {alertAction} from "../../reducers/alertReducer";

export default function AlertDialog() {

    const dispatch = useDispatch()
    const {open, title, text, disagreeText, agreeText, action} = useSelector((state) => state.alertReducer)

    const handleClose = () => {
        dispatch(alertAction({open: false}));
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} autoFocus>{disagreeText}</Button>
                <Button onClick={() => {
                    handleClose();
                    action()
                }}>{agreeText}</Button>
            </DialogActions>
        </Dialog>
    );
}
